import { render } from "./applications.vue?vue&type=template&id=26217c72&scoped=true"
import script from "./applications.vue?vue&type=script&lang=ts"
export * from "./applications.vue?vue&type=script&lang=ts"

import "./applications.vue?vue&type=style&index=0&id=26217c72&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-26217c72"

export default script